interface KPICardProps {
  value: string | number
  label: string
  sublabel?: string
  status?: 'good' | 'warning' | 'bad' | 'neutral'
  tooltip?: string
}

const STATUS_COLORS = {
  good: 'text-emerald-700 dark:text-emerald-400',
  warning: 'text-amber-700 dark:text-amber-400',
  bad: 'text-red-700 dark:text-red-400',
  neutral: 'text-slate-900 dark:text-slate-100',
}

export default function KPICard({ value, label, sublabel, status = 'neutral', tooltip }: KPICardProps) {
  return (
    <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 p-5 hover:border-blue-300 dark:hover:border-blue-700 transition-colors" title={tooltip}>
      <div className={`text-2xl font-bold font-[family-name:var(--font-display)] ${STATUS_COLORS[status]}`}>
        {value}
      </div>
      <div className="text-xs font-medium uppercase tracking-wider text-slate-500 dark:text-slate-400 mt-1.5">
        {label}
      </div>
      {sublabel && <div className="text-xs text-slate-400 mt-1">{sublabel}</div>}
    </div>
  )
}
